<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 70px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 40px;
          display: flex;
          font-size: 18px;
          font-weight: bold;
          align-items: center;
        "
      >
        <!-- <div style="color: #000">
          <span style="cursor: pointer" @click="$router.go(-2)">项目</span>
          <i class="el-icon-arrow-right"></i>
        </div> -->
        <div style="margin-right: 10px;">
      <el-button type="primary" @click="$router.go(-1)">返回</el-button>
    </div>
        <div style="color: #000">
          <span style="cursor: pointer" @click="$router.go(-1)">{{
            backName || "工作台"
          }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div style="color: #606266" class="ellipsis">BIM模型</div>
      </div>
      <div>开发中.....</div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      backName: "",
      pId: "",
    };
  },
  props: {},
  components: {},
  methods: {},
  mounted() {},
  created() {
    this.pId = this.$route.query.id;
    this.backName = this.$route.query.name;
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped></style>
